import request from '@/utils/request'

// 获取访客列表（走主后端 visit.listVisits，不依赖 IOT）
export function listVisits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/visit.listVisits',
      method: 'get',
      params: {
        ...params,
        channel: 'PC'
      }
    }).then(response => {
      const res = response.data
      // 后端 ApiVisitVo 顶层字段是 visits（不是 data）
      const visits = (res.visits || []).map(v => ({
        ...v,
        visitId: v.vId,
        name: v.vName
      }))
      resolve({
        data: visits,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取访客类型列表
export function listVisitTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/iot.getOpenApi',
      method: 'get',
      params: {
        ...params,
        iotApiCode: 'listVisitTypeBmoImpl'
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}